export default {
    G1:{
        'event': 'navigation',
        'navigation': 'navigation',
        'navigationSection': 'global', 
        'navigationText': 'logo',
        'siteSection': 'global nav',
        'buttonLocation': 'top'
    }, 
    G2:{
        'event': 'navigation',
        'navigation': 'navigation',
        'navigationSection': 'global', 
        'navigationText': 'our priorities', //e.g., 'our priorities'
        'siteSection': 'mobile global nav',
        'buttonLocation': 'top'
    }, 
    G3:{
        'event': 'navigation',
        'navigation': 'navigation',
        'navigationSection': 'global', 
        'navigationText': 'institute for sustainable finance', //e.g., 'our priorities'
        'siteSection': 'mobile global nav',
        'buttonLocation': 'top'
    }, 
    G4:{
        'event': 'navigation',
        'navigation': 'navigation',
        'navigationSection': 'global', 
        'navigationText': 'housing affordability',
        'siteSection': 'mobile global nav',
        'buttonLocation': 'top'
    },
    G5:{
        'event': 'navigation',
        'navigation': 'navigation',
        'navigationSection': 'global', 
        'navigationText': 'home',
        'siteSection': 'global nav',
        'buttonLocation': 'top'
       }, 
    G6:{
        'event': 'navigation',
        'navigation': 'navigation',
        'navigationSection': 'global', 
        'navigationText': 'map',
        'siteSection': 'global nav',
        'buttonLocation': 'top'
    },
    map:{

    },
    footer:{
        'event': 'scroll',
        'scrollType': 'section',
        'scrollSection': 'footer', // e.g., "housing" 
        'siteSection': 'footer', // e.g., "housing"
    },
    "open-hamburger":{
        'event': 'navigation',
        'navigation': 'navigation',
        'navigationSection': 'global', 
        'navigationText': 'open hamburger',
        'siteSection': 'global nav',
        'buttonLocation': 'top'
    }, 
    "close-hamburger":{
        'event': 'navigation',
        'navigation': 'navigation',
        'navigationSection': 'global', 
        'navigationText': 'close hamburger',
        'siteSection': 'global nav',
        'buttonLocation': 'top'
    }
};